import Vue           from 'vue'
import App           from '@/App.vue'
import router        from '@/services/router'
import vuetify       from '@/plugins/vuetify';
import { createPinia, PiniaVuePlugin } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'

import '@/plugins/download'
import '@/plugins/dayjs'
import '@/plugins/apexchart'
import '@/plugins/api'
import '@/plugins/build'
import '@/plugins/storage'
import '@/plugins/user'

import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);

Vue.use(PiniaVuePlugin)
export const pinia = createPinia()
const piniaStore = createPersistedState({
  key: id => `__persisted__${id}`
})
pinia.use(piniaStore)


// Event bus
Vue.prototype.$eventBus = new Vue({})

new Vue({
  vuetify,
  router,
  pinia,
  render: h => h(App)
}).$mount('#app')

//const isIOS = () => {
//  return [
//    'iPad Simulator',
//    'iPhone Simulator',
//    'iPod Simulator',
//    'iPad',
//    'iPhone',
//    'iPod'
//  ].includes(navigator.platform)
//  // Pour les nouveaux iPad sous iPadOS qui s'identifient comme "Mac"
//  || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
//};
//
//// Register our service worker (on désactive le service worker pour ios)
//if ( (process.env.NODE_ENV === 'production') && ('serviceWorker' in navigator) && !isIOS() ) {
//  navigator.serviceWorker.register('./sw.js').then(reg => {
//    
//    // On écoute si un nouveau SW arrive
//    reg.addEventListener('updatefound', () => {
//      const newWorker = reg.installing;
//      
//      newWorker.addEventListener('statechange', () => {
//        // Si le nouveau SW est installé et prêt (mais attend)
//        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
//          // ICI : Affiche ton interface (ex: un bouton "Mettre à jour")
//          showUpdateBar();
//        }
//      });
//    });
//  });
//} else if ('serviceWorker' in navigator) {
//  // En DEV : On force la désinstallation pour éviter les effets de bord
//  navigator.serviceWorker.getRegistrations().then(registrations => {
//    for (let registration of registrations) {
//      registration.unregister();
//      console.log('SW désinstallé (Mode Dev)');
//    }
//  });
//}

if ('serviceWorker' in navigator) {
  // En DEV : On force la désinstallation pour éviter les effets de bord
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (let registration of registrations) {
      registration.unregister();
      console.log('SW désinstallé (Mode Dev)');
    }
  });
}

//function showUpdateBar() {
//  const confirmUpdate = confirm("Une nouvelle version est disponible. Voulez-vous recharger la page ?");
//  if (confirmUpdate) {
//    window.location.reload();
//  }
//}